import * as actionTypes from '../Action/Actiontypes';

const initialstate = {
    loading: null,
    error: null,
    contact:{},
    review:{}
}


export const ContactReducer = (state = initialstate, action) => {
    switch (action.type) {
        case actionTypes.CONTACT_US_INIT:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.CONTACT_US_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                contact: action.payload,
                loading: false
            }
           
        case actionTypes.CONTACT_US_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
         //SENND REQ-REVIEW
         case actionTypes.SEND_REQ_REVIEW_INIT:
            return {
                ...state,
                loading: true,
            }
        case actionTypes.SEND_REQ_REVIEW_SUCCESS:
            console.log(action.payload)
            return {
                ...state,
                review: action.payload,
                loading: false
            }
           
        case actionTypes.SEND_REQ_REVIEW_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            }
        default:
            return state;
    }
}

